import Swiper from 'swiper';
import {Navigation, Pagination} from "swiper/swiper.esm";


Swiper.use([Navigation, Pagination]);
const industrySwiper = new Swiper(".hero-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    direction: 'horizontal',
    autoplay:{
        delay: 1500,
    },
    loop: 'true',
    pagination: {
        el: '.hero-swiper-pagination',
        type: 'bullets',
        renderBullet: function (index, className) {
            return '<button class="' + className + '" aria-label="Top Region Carousel Button '+ (index + 1) +'" type="button" aria-pressed="true"></button>';
        },
        clickable: true,
        bulletElement: 'button'
    },
});
